/**
 * Verification modal states.
 */
export enum VerificationState {
  EnterPin,
  EnterEmail,
}
